"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var contractTypeBuilder = function contractTypeBuilder(_a) {
  var _b = _a.contractType,
      contractType = _b === void 0 ? [] : _b;

  if (!contractType.length || contractType.length === Object.keys(_SearchFilters.ContractTypeValue).length) {
    return '';
  }

  var propertyArray = contractType.map(function (value) {
    return "contractType:" + value;
  });

  if (propertyArray.length === 1) {
    return propertyArray[0];
  }

  if (propertyArray.length > 1) {
    return "(" + propertyArray.join(' OR ') + ")";
  }

  return '';
};

var _default = contractTypeBuilder;
exports["default"] = _default;